import React, { FC } from "react";
import styled from "styled-components";
import { BodyDefault } from "../typography/styled";
import LinkIc from './Link.svg'

export const StyledLink = styled(BodyDefault)`
  color: ${({theme}) => theme.accent[100]};
  transition: color 0.15s ease-out;
`

export const LinkWrapper = styled.a`
  display: flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;

  &:hover{
    ${StyledLink} {
      color: ${({theme}) => theme.isDark ? theme.icon.secondary : theme.accent[200]};
    }
  }

  &:focus-visible {
    outline: none;
    border-radius: ${({theme}) => theme.radius.xs};
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`
type LinkProps = {
  link?: string,
  linkText: string,
  customStyles?: any,
}

const Link:FC<LinkProps> = (props) => {
  const {
    link,
    linkText,
    customStyles
  } = props
  return(
    <LinkWrapper style={customStyles} href={link}>
      <StyledLink>
        {linkText}
      </StyledLink>
      <img src={LinkIc}/>
    </LinkWrapper>
  )
}

export default Link
